document.addEventListener('DOMContentLoaded', function() {
  console.log("CUSTOM JS LOADING...");
  
  const enable_enforce_purchase_limit = "true";
  
  if (enable_enforce_purchase_limit == "true") {
    console.log("Purchase limit functionality activated.");
    // Combine SKUs from both sources
    let restrictedSKUs = [];
    
    // Add individual SKUs
    if (window.restrictedIndividualSKUs && window.restrictedIndividualSKUs.length > 0) {
      restrictedSKUs = [...restrictedSKUs, ...window.restrictedIndividualSKUs];
    }
    
    // Add collection SKUs
    if (window.restrictedSKUsFromCollection && window.restrictedSKUsFromCollection.length > 0) {
      restrictedSKUs = [...restrictedSKUs, ...window.restrictedSKUsFromCollection];
    }
    
    // Remove duplicates
    restrictedSKUs = [...new Set(restrictedSKUs)];
    
    // console.log('AAA Restricted SKUs loaded:', restrictedSKUs);
    
    if (restrictedSKUs.length === 0) {
      // console.log('AAA No restricted SKUs found, skipping limit enforcement');
      return;
    }
    
    // ... rest of your existing JavaScript code (monitoring, checking, etc.)
    // Flag to prevent infinite loops during cart updates
    let isUpdatingCart = false;
    let checkTimeout = null;
    
    // Function to check and enforce quantity limits
    function checkAndEnforceCartQuantity() {
      if (isUpdatingCart) return;
      
      // Clear any existing timeout
      if (checkTimeout) {
        clearTimeout(checkTimeout);
      }
      
      // Debounce the check to prevent multiple rapid calls
      checkTimeout = setTimeout(() => {
        // console.log('AAA Checking cart for restricted items...');
        
        isUpdatingCart = true;
        
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            let restrictedItemsInCart = [];
            let skuCountMap = {}; // Track how many of each SKU we have
            
            // Check each line item for restricted SKUs
            cart.items.forEach(item => {
              if(item.sku && restrictedSKUs.includes(item.sku.toLowerCase())) {
                // Track SKU count
                const skuLower = item.sku.toLowerCase();
                if (!skuCountMap[skuLower]) {
                  skuCountMap[skuLower] = {
                    items: [],
                    totalQuantity: 0
                  };
                }
                skuCountMap[skuLower].items.push(item);
                skuCountMap[skuLower].totalQuantity += item.quantity;
                
                restrictedItemsInCart.push({
                  id: item.id,
                  key: item.key,
                  sku: item.sku,
                  quantity: item.quantity,
                  variant_id: item.variant_id,
                  title: item.product_title
                });
              }
            });
            
            // console.log("AAA Restricted items found:", restrictedItemsInCart.length);
            
            // CHECK QUANTITIES AND REMOVE EXTRAS - The core functionality
            if(restrictedItemsInCart.length > 0) {
              let needsUpdate = false;
              let updates = {};
              
              // Check each SKU in the count map
              Object.keys(skuCountMap).forEach(sku => {
                const skuData = skuCountMap[sku];
                // console.log(`AAA Processing SKU ${sku}:`, skuData);
                
                // If total quantity for this SKU is greater than 1
                if(skuData.totalQuantity > 1) {
                  // console.log(`AAA SKU ${sku} has total quantity ${skuData.totalQuantity}, reducing to 1`);
                  
                  // We need to keep only 1 quantity total for this SKU
                  // Keep the first item, remove excess from all items of this SKU
                  let remainingToKeep = 1;
                  
                  skuData.items.forEach((item, index) => {
                    if (remainingToKeep > 0) {
                      // For the first item(s), reduce to 1 or less
                      if (item.quantity > 1) {
                        updates[item.key] = 1;
                        needsUpdate = true;
                        remainingToKeep = 0;
                      } else if (item.quantity === 1) {
                        // Already at 1, keep it
                        remainingToKeep = 0;
                      }
                    } else {
                      // For subsequent items, remove completely
                      updates[item.key] = 0;
                      needsUpdate = true;
                    }
                  });
                }
                
                // Check if any individual item has quantity > 1
                skuData.items.forEach(item => {
                  if (item.quantity > 1) {
                    updates[item.key] = 1;
                    needsUpdate = true;
                  }
                });
              });
              
              // Update cart if needed
              if(needsUpdate) {
                // console.log("AAA Cart needs update, performing update... Updates:", updates);
                updateCartQuantities(updates);
                return; // Return early, flag will be reset in updateCartQuantities
              }
            }
            
            isUpdatingCart = false;
            checkTimeout = null;
          })
          .catch(error => {
            console.error("AAA Error checking cart:", error);
            isUpdatingCart = false;
            checkTimeout = null;
          });
      }, 300); // 300ms debounce delay
    }
    
    // Start monitoring immediately since SKUs are already loaded
    startCartMonitoring();
    
    function startCartMonitoring() {
      // console.log("AAA Starting cart monitoring with restricted SKUs:", restrictedSKUs);
      
      // Initial check on page load
      checkAndEnforceCartQuantity();
      
      // ... rest of your existing monitoring code ...
      // Method 1: Hook into ALL fetch requests
      const originalFetch = window.fetch;
      
      window.fetch = function(...args) {
        const [resource, config] = args;
        
        // Check if this is ANY cart-related request
        if (typeof resource === 'string' && resource.includes('/cart/')) {
          // console.log("AAA Cart fetch request detected:", resource, config?.method);
          
          // Store the original promise
          const fetchPromise = originalFetch.apply(this, args);
          
          // Check cart after the request completes
          fetchPromise
            .then(response => {
              // console.log("AAA Cart request completed, checking quantities...");
              setTimeout(checkAndEnforceCartQuantity, 100);
              return response;
            })
            .catch(error => {
              console.error("AAA Cart request failed:", error);
              return Promise.reject(error);
            });
          
          return fetchPromise;
        }
        
        return originalFetch.apply(this, args);
      };
      
      // ... (keep all your existing monitoring methods) ...
    }
    
    function updateCartQuantities(updates) {
      // console.log("AAA Updating cart quantities:", updates);
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then(cart => {
        // console.log("AAA Cart updated successfully");
        isUpdatingCart = false;
        checkTimeout = null;
        
        // Only reload if there were actual changes
        if (Object.keys(updates).length > 0) {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        } else {
          isUpdatingCart = false;
        }
      })
      .catch(error => {
        // console.error("AAA Error updating cart:", error);
        isUpdatingCart = false;
        checkTimeout = null;
      });
    }
  }
  
  console.log("CUSTOM JS LOADED");
});